var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"agenda-filter-top"},[_c('span',[_vm._v(_vm._s(_vm.total)+" sessions")]),_vm._v(" "),_c('span',[_c('c-button',{attrs:{"theme":"default","icon":"fa-filter-slash","size":"sm","uppercase":"","fill":""},on:{"click":function($event){return _vm.$emit('reset')}}},[_vm._v("Reset")])],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }